// Localised group display names (i18n labels for layer groupings).
// Extracted from rawConfig.ts as part of Phase 2.3 (ANALYSIS.md §5.11).

export const groupAliases = {
  bg: {
    properties: 'Собственост',
    common: 'Общи',
    reg: 'Регулации',
    oup: 'ОУП',
    und: 'Подземни проводи и съоръжения',
    zones: 'Устройствени зони',
    zonelines: 'Застроителни линии',
    cad: 'Кадастрална карта',
    streetreg: 'Улична регулация',
    Containers: 'УПРАВЛЕНИЕ НА ОТПАДЪЦИТЕ',
    velo: 'ВЕЛОМОБИЛНОСТ',
    parkings: 'ПАРКИНГИ И ЗОНИ ЗА ПАРКИРАНЕ',
    healthFacilities: 'ЗДРАВЕ И СПОРТ',
    repairs: 'РЕМОНТИ',
    events: 'Туристически обекти и събития',
    archimport: 'Инвестиционни проекти',
    misc: 'Кадастрален План, Визи и Други',
    crosses: 'Координатни кръстове'
  }
}
